<div class="rounded-2xl bg-yellow-200 px-4 py-2 w-full space-y-2 text-gray-900">
  <div class="flex items-center gap-2">
    <app-icon name="paper" class="w-5 h-5 text-gray-600" />
    <span class="text-gray-600">Paper Type:</span>
    <span class="font-semibold">{{ order().paperType }}</span>
  </div>
  <div class="flex items-center gap-2">
    <app-icon name="size" class="w-5 h-5 text-gray-600" />
    <span class="text-gray-600">Size:</span>
    <span class="font-semibold">{{ order().size.width }} x {{ order().size.height }}</span>
  </div>
  <div class="flex items-center gap-2">
    <app-icon name="euro" class="w-5 h-5 text-gray-600" />
    <span class="text-gray-600">Unit Price:</span>
    @if (order().promotion) {
      <span class="line-through text-gray-500">{{ order().size.price | currency:'EUR':'symbol':'1.2-2':'en-US' }}</span>
      <span class="font-semibold text-green-600">{{ getDiscountPrice() | currency:'EUR':'symbol':'1.2-2':'en-US' }}</span>
    } @else {
      <span class="font-semibold">{{ order().size.price | currency:'EUR':'symbol':'1.2-2':'en-US' }}</span>
    }
  </div>
  <div class="flex items-center gap-2">
    <app-icon name="message" class="w-5 h-5 text-gray-600" />
    <span class="text-gray-600">Message:</span>
    <span class="font-semibold">{{ order().message }}</span>
  </div>
</div>
